import React, { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AxiosClient from '../../assets/AxiosClient';
import { useStateContext } from '../../Contexts/ContextProvider';
import { FormActions } from '../../componants/Workspace';
import LocationPicker from './LocationPicker';

const AddConferences = () => {
  const { SetNotification } = useStateContext();
  const navigate = useNavigate();
  
  // Refs for form fields
  const titleArRef = useRef(null);
  const titleEnRef = useRef(null);
  const sloganArRef = useRef(null);
  const sloganEnRef = useRef(null);
  const startDateRef = useRef(null);
  const endDateRef = useRef(null);
  const locationNameRef = useRef(null);
  const locationArNameRef = useRef(null);
  const latitudeRef = useRef(null);
  const longitudeRef = useRef(null);
  const logoRef = useRef(null);

  const [isSending, setIsSending] = useState(false);
  const [showLocationPicker, setShowLocationPicker] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSending(true);

    const formData = new FormData();
    formData.append('ar_title', titleArRef.current.value);
    formData.append('en_title', titleEnRef.current.value);
    formData.append('ar_slogan', sloganArRef.current.value);
    formData.append('en_slogan', sloganEnRef.current.value);
    formData.append('start_date', startDateRef.current.value);
    formData.append('end_date', endDateRef.current.value);
    formData.append('location_name', locationNameRef.current.value);
    formData.append('ar_location_name', locationArNameRef.current.value);
    formData.append('latitude', latitudeRef.current.value);
    formData.append('longitude', longitudeRef.current.value);
    
    if (logoRef.current.files[0]) {
      formData.append('logo', logoRef.current.files[0]);
    }

    try {
      const response = await AxiosClient.post('/conferences', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      if (response.status === 201) {
        SetNotification('Conference created successfully', 'success');
        navigate(-1);
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'An error occurred while creating the conference.';
      SetNotification(errorMessage, 'danger');
    }

    setIsSending(false);
  };

  return (
    <div className="m-4">
      <form className="form-group" onSubmit={handleSubmit}>
        <h5>عنوان المؤتمر باللغة العربية</h5>
        <div className="input-group input-group-outline mb-3">
          <input type="text" className="form-control" placeholder="Enter Arabic title" ref={titleArRef} required />
        </div>

        <h5>Conference Title in English</h5>
        <div className="input-group input-group-outline mb-3">
          <input type="text" className="form-control" placeholder="Enter English title" ref={titleEnRef} required />
        </div>

        <h5>شعار المؤتمر باللغة العربية</h5>
        <div className="input-group input-group-outline mb-3">
          <input type="text" className="form-control" placeholder="Enter Arabic slogan" ref={sloganArRef} required />
        </div>

        <h5>Conference Slogan in English</h5>
        <div className="input-group input-group-outline mb-3">
          <input type="text" className="form-control" placeholder="Enter English slogan" ref={sloganEnRef} required />
        </div>

        <h5>Start Date</h5>
        <div className="input-group input-group-outline mb-3">
          <input type="datetime-local" className="form-control" ref={startDateRef} required />
        </div>

        <h5>End Date</h5>
        <div className="input-group input-group-outline mb-3">
          <input type="datetime-local" className="form-control" ref={endDateRef} required />
        </div>

        <h5>English Location Name</h5>
        <div className="input-group input-group-outline mb-3">
          <input type="text" className="form-control" placeholder="Enter location" ref={locationNameRef} required />
        </div>

        <h5>Arabic Location Name</h5>
        <div className="input-group input-group-outline mb-3">
          <input type="text" className="form-control" placeholder="Enter Arabic location" ref={locationArNameRef} required />
        </div>

        <h5>Latitude</h5>
        <div className="input-group input-group-outline mb-3">
          <input type="number" className="form-control" placeholder="Enter latitude" ref={latitudeRef} step="any" min="-90" max="90" required />
        </div>

        <h5>Longitude</h5>
        <div className="input-group input-group-outline mb-3">
          <input type="number" className="form-control" placeholder="Enter longitude" ref={longitudeRef} step="any" min="-180" max="180" required />
        </div>
        <button type="button" className="btn btn-outline-info mb-3" onClick={() => setShowLocationPicker(true)}>
          Set location on map
        </button>

        <h5>Logo</h5>
        <div className="input-group input-group-outline mb-3">
          <input type="file" className="form-control" ref={logoRef} accept="image/*" />
        </div>

        <hr className="border-gray-300 my-4" />

        <FormActions>
          {isSending ? <span role="status">Saving conference...</span> : (
          <button type="submit" className="btn btn-info m-2">
            Create conference
          </button>
          )}
        </FormActions>
      </form>
      {showLocationPicker && (
        <LocationPicker
          address={locationNameRef.current?.value || ''}
          latitude={latitudeRef.current?.value || ''}
          longitude={longitudeRef.current?.value || ''}
          onClose={() => setShowLocationPicker(false)}
          onSelect={(latitude, longitude) => {
            latitudeRef.current.value = latitude.toFixed(6);
            longitudeRef.current.value = longitude.toFixed(6);
          }}
        />
      )}
    </div>
  );
};

export default AddConferences;
